import { render, staticRenderFns } from "./comp_ProductCardRating.vue?vue&type=template&id=ed15090e"
import script from "./comp_ProductCardRating.vue?vue&type=script&lang=js"
export * from "./comp_ProductCardRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
